import { fetchAllPropEventTickets, fetchFinalizedPropTicketsPage, finalizedTicketIdsByPageSelector, makeFinalizedTicketsByPageSelector, makeUserTicketsByStatusSelector } from '@ogsnetwork/opp-redux-lib';
import { useCallback, useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from './index';
import { getLastLoadedPage } from './utils/pagination';
const LIVE_TICKET_REFRESH_INTERVAL = 60 * 1000;
export function useMyContests(props) {
    const { page = 1 } = props;
    const dispatch = useAppDispatch();
    const userTicketByStatusSelector = useMemo(makeUserTicketsByStatusSelector, []);
    const userFinalizedTicketByPageSelector = useMemo(makeFinalizedTicketsByPageSelector, [page]);
    const tickets = useAppSelector((state) => {
        if (props.status === 'completed') {
            return userFinalizedTicketByPageSelector(state, { page });
        }
        return userTicketByStatusSelector(state, { status: props.status });
    });
    const finalizedTicketsByPage = useAppSelector(finalizedTicketIdsByPageSelector);
    const { hasNextPage } = useAppSelector((state) => state.tickets);
    const dispatchFetchTickets = useCallback(() => {
        if (props.status === 'completed') {
            dispatch(fetchFinalizedPropTicketsPage(page));
        }
        else {
            dispatch(fetchAllPropEventTickets());
        }
    }, [page, props.status]);
    useEffect(() => {
        dispatchFetchTickets();
    }, [page]);
    function refresh() {
        dispatchFetchTickets();
    }
    useEffect(() => {
        dispatchFetchTickets();
        if (props.status === 'live' || props.status === 'upcoming') {
            const refreshTicketsInterval = setInterval(() => refresh(), LIVE_TICKET_REFRESH_INTERVAL);
            return () => {
                clearInterval(refreshTicketsInterval);
            };
        }
    }, [props.status]);
    return {
        tickets,
        hasNextPage: page < getLastLoadedPage(finalizedTicketsByPage) || hasNextPage,
        refresh
    };
}
